export const getErrorMessage = (error) => {
    let result = error.message; // default value
    if (error.response && error.response.data) {
        result = error.response.data;
        try {
            const parsedMessage = error.response.data;
            if (parsedMessage.Message) {
                result = parsedMessage.Message;
            }
        }
        catch(ex) {
        }
    }

    return result;
};

export const getErrorResponseForLinkedUsers = (error) => {
    try {
        var messageObject = error.response.data;
        messageObject.Message = scrub(messageObject.Message);
        return messageObject;
    }
    catch (ex) {
        return {
            ErrorCode: 0,
            Message: "Internal server error",
            AdditionalData: null
        };
    }
};

export const scrub = (errorMessage) => {
    // eslint-disable-next-line no-useless-escape
    var credRegEx = /(((?:organization|user){1}?.*(not found){1}?)|(invalid parameter.*(?:password|login|site|userid))|(wrong password)|(ipaddress\=))/i;
    var credentials = errorMessage.search(credRegEx);
    return credentials >= 0
        ? "Invalid Credentials"
        : errorMessage;
};
